/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : ShippingAndBillingInfoComponent.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H224423
 *
 * @Date         : Oct 21, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : H224423
 * On            : Oct 21, 2019
 * Description   : ASDS-1548 changes.Added Modification History.
*******************************************************************************/
import * as React from "react";
import { Redirect } from 'react-router-dom';
import {
    Grid,
} from "@scuf/common";
//This function is used to display the component related to Shipping and Billing Info
import {
    IAddEmailAddress, IShippingAndBillingAddressProps,
    IShippingAndBillingInfoComponentProps
} from "../utils/checkout-interfaces";
import RouteConstants from "../constants/route-constants";
import { connect } from "react-redux";
import { mapSelectAccountToProps } from "../ShippingAndBilling/ShippingAndBillingAddress";

import BillingAddress from './BillingAddress';
import ShippingAddress from './ShippingAddress';

export function ShippingAndBillingInfoComponent(props: IShippingAndBillingInfoComponentProps) {
    if (props.soldToShipTo.shipTo && props.soldToShipTo.soldTo) {
        return (
            <Grid.Row>
                <Grid.Column width={6} sWidth={12} className="bill-info">
                    <BillingAddress addressDetails={props.soldToShipTo.soldTo} />
                </Grid.Column>
                <Grid.Column width={6} sWidth={12} className="ship-info">
                    <ShippingAddress
                        addressDetails={props.soldToShipTo.shipTo}
                        emailAddressArr={props.emailAddressArr}
                    />
                </Grid.Column>
            </Grid.Row>
        )
    }
    return (
        <Redirect to={RouteConstants.SELECT_ACCOUNT} />
    );

}

export function mapShippingAndBillingInfoComponentStateToProps(state): IShippingAndBillingInfoComponentProps {
    const soldToShipTo: IShippingAndBillingAddressProps = mapSelectAccountToProps(state);
    const emailAddressArr: IAddEmailAddress[] = state.shippingBillingData.payload.shippingBillingObj.emailAddress;
    return {
        soldToShipTo,
        emailAddressArr,
    }

}

export default connect(mapShippingAndBillingInfoComponentStateToProps, {})(ShippingAndBillingInfoComponent);